import React from 'react';
import { AppstoreOutlined } from '@ant-design/icons';
import {
    EmptyStateBlock,
    EmptyStateIcon,
    EmptyStateTitle,
    EmptyStateDescription,
} from './style';

export default function AssetsManager() {
    return (
        <EmptyStateBlock>
            <EmptyStateIcon>
                <AppstoreOutlined />
            </EmptyStateIcon>
            <EmptyStateTitle>Assets Manager</EmptyStateTitle>
            <EmptyStateDescription>
                Assets Manager module is connected. Replace this screen with your integrated app shell.
            </EmptyStateDescription>
        </EmptyStateBlock>
    );
}

